import { useTheme } from '@mui/material/styles'
import { useMemo } from 'react'
import { useChat } from '../context/ChatProvider'

const getInitials = (name: string) =>
  name
    .split(' ')
    .map(chunk => chunk.charAt(0))
    .join('')
    .toUpperCase()

export const ChatHeader = () => {
  const theme = useTheme()
  const { conversation, participantDisplayName, participantAvatarUrl } =
    useChat()

  const fallbackAvatarStyle = useMemo(
    () => ({
      background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
      color: theme.palette.primary.contrastText,
    }),
    [
      theme.palette.primary.contrastText,
      theme.palette.primary.dark,
      theme.palette.primary.main,
    ]
  )

  const title =
    participantDisplayName ??
    conversation?.friendlyName ??
    conversation?.uniqueName ??
    'Secure Chat'

  return (
    <div className="flex items-center justify-between gap-4 px-6 py-5 border-b border-slate-100">
      <div className="flex items-center gap-4">
        {participantAvatarUrl ? (
          <img
            src={participantAvatarUrl}
            alt={title}
            className="object-cover w-12 h-12 shadow-lg rounded-2xl"
          />
        ) : (
          <div
            className="flex items-center justify-center w-12 h-12 text-base font-semibold shadow-lg rounded-2xl"
            style={fallbackAvatarStyle}
          >
            {getInitials(title)}
          </div>
        )}
        <div>
          <p className="text-lg font-semibold text-slate-800">{title}</p>
          {/* <p className="text-sm text-slate-500">Confidential messaging</p> */}
        </div>
      </div>
    </div>
  )
}
